<template>
<div class="ut-relative">
  <div class="search-input input">
    <input class="ga-event" v-on:focus="onFocus" v-on:keyup="coreLogicSearch" v-model="searchTerm" ref="suburbInput" type="text" value="" :placeholder="placeholder" :disabled="isDisabled == true" 
    :data-category="dataCategory" :data-eventlabel="dataCategory" />
  </div>
  <search-results :results="searchResults" :searchType="searchType" @selectedResult="updateSelectedAddress"></search-results>
</div>
</template>

<script>
import axios from 'axios';
import SearchResults from '@/components/forms/search/searchResults/SearchResults.vue';
import analyticsHelpers from '../../../helpers/analytics-helpers';

const geocoder = new google.maps.Geocoder();

export default {
  name: 'AddressSearch',
  components: {
    SearchResults,
  },
  props: {
    existingAddress: {
      required: false,
      default: null,
    },
    dataCategory: null,
    dataEventLabel: null,
    placeholderText: null,
    disabled: false,
    clearInput: null,
  },
  data() {
    return {
      searchTerm: this.existingAddress,
      searchResults: [],
      searchType: 'address',
      selectedResult: null,
      placeholder: this.placeholderText,
      isDisabled: this.disabled,
    };
  },
  watch: {
    disabled: {
      handler: function() {
        this.isDisabled = this.disabled;
      },
    },
    clearInput: {
      handler: function() {
        this.searchTerm = '';
      },
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => this.$refs.suburbInput.focus());
  },
  methods: {
    coreLogicSearch() {

      this.$emit('startedTyping', this.searchTerm);

      if (this.searchTerm.length >= 2) {
        axios.get(`${process.env.VUE_APP_CLAPI_URL}/v1/PropertySearch/autocomplete?address=${this.searchTerm}`)
          .then((response) => {
            this.searchResults = response.data.data;

            if (this.searchResults.length === 0) {
              this.googleSearch();
            }
          })
          .catch((error) => {
            this.searchResults = [];
            this.googleSearch();
          });
      } else {
        this.hideResults();
      }
    },
    onFocus() {
      analyticsHelpers.gaEvent(this.gacategory, 'CTA input - Focus', '');
    },
    googleSearch() {
      geocoder.geocode({
        address: this.searchTerm,
        region: 'AU'
      }, (results, status) => {
        if (status == 'OK' && results && results.length > 0) {
          function parseGeocode(geocode) {
            const r = geocode.formatted_address;
            const pos = geocode.geometry.location;

            try {
              return {
                latitude: pos.lat,
                longitude: pos.lng,
                streetaddress: r.split(',')[0],
                suburb: r.split(',')[1].match(/[A-Z][^A-Z0-9\s]+\s?/g).join('').replace(/\s+$/, ''),
                state: r.split(',')[1].match(/\b[A-Z]+\b/)[0],
                postcode: r.split(',')[1].match(/\d{4}/)[0],
                geolocationtype: geocode.geometry.location_type,
              };
            } catch (err) {
              console.error(`Error while parsing address ${r}`);
              return null;
            }
          }

          const filterSearchResults = this.filterGeocode(results, true)
            .map((x) => {
              // console.log(x);
              const r = x.formatted_address.split(',').slice(0, 2).join('');
              return {
                id: null,
                address: r,
                details: parseGeocode(x),
              };
            }).filter(x => !!x);


          this.searchResults = filterSearchResults;
        } else {
          this.searchResults = [];
        }
      });
    },
    filterGeocode(results, filterForRealAddresses) {
      // remove results that aren't an Australian address
      return results.filter((x) => {
        var is_address = true;
        if (filterForRealAddresses) {
          var is_address = x.address_components
            .filter(y => y.types.indexOf('street_number') != -1)
            .length > 0;
        }
        const is_aus = !!x.formatted_address.match(/Australia/);
        return is_aus && is_address;
      });
    },
    getCLPropertyDetails(id) {
      return axios.get(`${process.env.VUE_APP_CLAPI_URL}/v1/property/details?id=${id}`)
        .then((response) => {
          if (response.data.success) {
            return response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    hideResults() {
      this.searchResults = [];
    },
    updateSelectedAddress(selected) {
      this.searchTerm = selected.address;
      this.selectedResult = selected.address;

      analyticsHelpers.gaEvent(this.gacategory, 'CTA input - Selected address', selected.address);

      console.log(selected);

      // we have a CL property
      if (selected.id != null) {
        selected.source = 'cl';

        this.getCLPropertyDetails(selected.id).then((res) => {
          // console.log(res);

          selected.details = res;
          this.$emit('selectedResult', selected);
          this.hideResults();
        });
      }
      // We have a google property
      else {
        selected.id = null;
        selected.source = 'google';

        this.$emit('selectedResult', selected);
        this.hideResults();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-input {
    input {
        outline: none;
    }
}
</style>
